import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, publishLast, switchMap, refCount, publishReplay } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { EQueryDetails } from '../models/e-query-details';
import { Settings } from '../../core';
import { EQueryResponse } from '../models/e-query-response';
import { ActivityLogger } from '../../activities/activity-logger';

@Injectable()
export class EQueryDetailsStorage {
    private readonly responseKey = 'eQueryResponsePostRequestKey';

    constructor(
        protected readonly settings: Settings,
        protected readonly http: HttpClient,
        private readonly activityLogger: ActivityLogger,
    ) {}

    public getInvestigatorEQueryDetails(eQueryId$: Observable<number>) {
        return eQueryId$.pipe(
            switchMap(eQueryId => this.loadEQueryDetails(`${this.settings.apiUrl}/investigator/e-queries/${eQueryId}`)),
            publishReplay(1),
            refCount(),
        );
    }

    public getSponsorEQueryDetails(eQueryId$: Observable<number>) {
        return eQueryId$.pipe(
            switchMap(eQueryId => this.loadEQueryDetails(`${this.settings.apiUrl}/sponsor/e-queries/${eQueryId}`)),
            publishReplay(1),
            refCount(),
        );
    }

    public createEQueryResponse(eQueryId: number, response: EQueryResponse) {
        const formData: FormData = new FormData();

        formData.append(this.responseKey, JSON.stringify(response));
        if (response.files) {
            const fileContent = response.files.keys();

            for (let file of fileContent) {
                formData.append('file', file, file.name);
            }

            if (response.files.size > 0) {
                this.activityLogger.logActivity('Upload Attachment');
            }
        }

        return this.http.post(`${this.settings.apiUrl}/external-user/e-queries/${eQueryId}/responses`, formData, {reportProgress: true});
    }

    private loadEQueryDetails( url: string): Observable<EQueryDetails> {
        return this.http.get<object>(url)
            .pipe(
                map((response) => {
                    return deserialize(response, EQueryDetails);
                }),
                publishLast(),
                refCount(),
            );
    }
}
